import { FormattedMessage } from 'react-intl';

export const ContactType = {
  CUSTOMER_INFO: 'customerInfo',
  ADDITIONAL_CUSTOMER_INFO: 'additionalCustomer.info',
};

export type ContactType = typeof ContactType[keyof typeof ContactType];

export const RadioContactOptions = [
  {
    value: ContactType.CUSTOMER_INFO,
    label: <FormattedMessage id="page.fiche.contact.mainContact" defaultMessage="Main contact" />,
  },
  {
    value: ContactType.ADDITIONAL_CUSTOMER_INFO,
    label: <FormattedMessage id="page.fiche.contact.additionalContact" defaultMessage="Additional contact" />,
  },
];
